export default function Header() {
  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <a href="/" className="flex items-center gap-2 cursor-pointer">
            <div className="w-10 h-10 bg-teal-600 rounded-lg flex items-center justify-center">
              <i className="ri-bank-card-line text-white text-xl"></i>
            </div>
            <span className="text-xl font-bold text-gray-900">クレカ比較ナビ</span>
          </a>
          
          <nav className="hidden md:flex items-center gap-8">
            <a href="/" className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap">
              ホーム
            </a>
            <a href="/ranking" className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap">
              ランキング
            </a>
            <a href="/comparison" className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap">
              カード比較
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
}
